import { render } from "./IconShip.vue?vue&type=template&id=604f4064"
import script from "./IconShip.vue?vue&type=script&lang=ts"
export * from "./IconShip.vue?vue&type=script&lang=ts"
script.render = render

export default script